import {Alert, FormControl, FormControlLabel, FormLabel, Icon, Radio, RadioGroup, Typography} from "@mui/material";
import {useAppDispatch, useAppSelector} from "../../../hooks/reduxHooks";
import {answer, selectActiveStep} from "../../../slices/CustomerDataSlice";

export default function AppStep(props: { step: number }) {
    const step = useAppSelector(state => selectActiveStep(state, props.step));
    const dispatch = useAppDispatch();

    const answerToQuestion = (index: number) => {
        return step.answers.find(a => a.index === index)?.answer ?? null;
    }

    const hasError = (index: number) => {
        return step.showErrors && !step.answers.find(a => a.index === index);
    }

    const handleAnswer = (index: number, res: boolean) => {
        dispatch(answer({step: props.step, index, answer: res}));
    }

    return (
        <>
            <Typography fontSize='18px' fontWeight={700}>
                {step.title}
            </Typography>
            <Typography>
                {step.description}
            </Typography>

            {step.questions.map((question, index) => (
                <FormControl key={question}>
                    <FormLabel>
                        {question}
                    </FormLabel>
                    <RadioGroup value={answerToQuestion(index)}>
                        <FormControlLabel onClick={() => handleAnswer(index, true)} value={true}
                                          control={<Radio checkedIcon={<Icon color='success'>check</Icon>}/>}
                                          label="بله"/>
                        <FormControlLabel onClick={() => handleAnswer(index, false)} value={false}
                                          control={<Radio checkedIcon={<Icon color='warning'>error</Icon>}/>}
                                          label="خیر"/>
                    </RadioGroup>

                    {
                        hasError(index) && (
                            <Alert severity='error'>به این سوال پاسخ نداده‌اید.</Alert>
                        )
                    }
                </FormControl>
            ))}
        </>
    )
}
